import { HiUser } from "react-icons/hi";

const Row = ({ label, children }) => (
  <div className="flex items-center justify-between px-5 py-2.5">
    <span className="text-sm text-gray-500">{label}</span>
    {children}
  </div>
);

const STAGE_COLORS = {
  customer: "bg-blue-50 text-blue-700",
  prospect: "bg-purple-50 text-purple-700",
  churned: "bg-gray-100 text-gray-600",
};

export const ClientOverviewCard = ({ account }) => {
  const {
    csOwner,
    stage,
    mrr,
    arr,
    clientSinceFull,
    renewalDate,
    lifespan,
    cltv,
    subscriptionStatus,
  } = account;

  const isPilot = subscriptionStatus === "pilot";

  return (
    <div className="rounded-xl border border-gray-200 bg-white">
      <div className="border-b border-gray-200 px-5 py-4">
        <h2 className="text-base font-semibold text-gray-900">
          Client overview
        </h2>
      </div>
      <div className="divide-y divide-gray-100">
        <Row label="CS Owner">
          {csOwner ? (
            <span className="text-sm font-medium text-gray-900">{csOwner}</span>
          ) : (
            <HiUser className="size-4 text-gray-400" />
          )}
        </Row>
        <Row label="Stage">
          <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${
              STAGE_COLORS[stage?.toLowerCase()] ?? "bg-gray-100 text-gray-600"
            }`}
          >
            {stage}
          </span>
        </Row>
        {/* Non-pilot label stays EXACTLY "MRR (Current)" — this PR's contract is that
            subscription accounts render unchanged (review 2026-07-03). */}
        <Row label={isPilot ? "Pilot MRR" : "MRR (Current)"}>
          <span className="text-sm font-medium text-gray-900">{mrr}</span>
        </Row>
        <Row label={isPilot ? "Pilot ARR" : "ARR"}>
          <span className="text-sm font-medium text-gray-900">{arr}</span>
        </Row>
        <Row label="Client Since">
          <span className="text-sm font-medium text-gray-900">
            {clientSinceFull}
          </span>
        </Row>
        <Row label={isPilot ? "Pilot end date" : "Renewal Date"}>
          <span className="text-sm font-medium text-gray-900">
            {renewalDate}
          </span>
        </Row>
        <Row label="Customer Lifespan">
          <span className="text-sm font-medium text-gray-900">{lifespan}</span>
        </Row>
        <Row label="Customer Lifetime Value (CLTV)">
          <span className="text-sm font-medium text-gray-900">{cltv}</span>
        </Row>
      </div>
    </div>
  );
};
